import { Card } from "../components/common/Card";
import CTA from "../components/common/CTA";
import Hero from "../components/common/Hero";
import { Stat } from "../components/common/Stat";
import WriteUps from "./WriteUps";

export default function Home() {
  const stats = [
    { number: "5,000+", label: "Lives Impacted" },
    { number: "120+", label: "Volunteers" },
    { number: "35", label: "Communities" },
    { number: "10+", label: "Years of Service" },
  ];

  const programs = [ 
    {
      title: "Faith in Action",
      text:
        "We support individuals on their journey of faith, healing, and self-discovery by nurturing inner growth, encouraging reflection, and helping people discover purpose, identity, and hope. Through mentorship, prayerful support, and compassionate relationships, we walk alongside individuals as they grow spiritually, emotionally, and personally.",
    },
    {
      title: "Compassionate Outreach & Practical Support",
      text:
        "We address real-life challenges by meeting practical needs, supporting vulnerable individuals and families, and offering care that reflects Christ’s compassion and deep respect for human dignity.",
    },
    {
      title: "Empowerment & Life Development",
      text:
        "We help individuals build confidence, resilience, and purpose through guidance, encouragement, and empowerment initiatives that promote independence, stability, and long-term wellbeing.",
    },
    {
      title: "Community & Relationship Building",
      text:
        "We work within communities to strengthen connections, restore trust, and promote unity recognizing that transformed lives contribute to stronger, healthier communities.",
    },
  ];

  // const testimonies = [
  //   {
  //     name: "Amina Bello",
  //     role: "Scholarship Beneficiary",
  //     story:
  //       "Because of Queen Esther's Foundation, I was able to return to school and complete my secondary education. Today, I dream bigger and believe in my future.",
  //   },
  //   {
  //     name: "Samuel Okorie",
  //     role: "Community Youth Leader",
  //     story:
  //       "The skills acquisition program transformed many youths in our community. We are now self-reliant and contributing positively to society.",
  //   },
  //   {
  //     name: "Grace Adeyemi",
  //     role: "Health Outreach Beneficiary",
  //     story:
  //       "The free medical outreach saved my life. I received care when I had no money, and I will forever be grateful.",
  //   },
  // ];

  return (
    <main className="flex flex-col">
      {/* Hero Section */}
      <Hero />

      {/* Impact Stats */}
      <section className="bg-[#F3E8FF] py-20">
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-center px-6">
          {stats.map((stat) => (
            <Stat key={stat.label} number={stat.number} label={stat.label} />
          ))}
        </div>
      </section>

      {/* What We Do / Programs */}
      <section className="py-20 px-6 max-w-7xl mx-auto">
        <h2 className="text-4xl font-bold text-center mb-12 text-[#2D033B]">
          What We Do
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {programs.map((prog) => (
            <Card key={prog.title} title={prog.title} text={prog.text} />
          ))}
        </div>
      </section>

      {/* Testimonials */}
    
<WriteUps/>
      {/* CTA */}
      <div className="w-full bg-[#F3E8FF]">
        <CTA
          title="You Can Make a Difference Today"
          subtitle="Every contribution helps us reach more lives and build stronger communities."
          buttonText="Donate Now"
          buttonLink="/donate"
          variant="primary"
        />
      </div>
    </main>
  );
}
